import React from "react";

export function AddNotificationModalBody(props) {
    return <div className="modal-body">
        <div className="tabs flex justify-between">
            <button
                className={`tab ${props.activeTab === 1 ? "active-tab bg-primaryColor text-white" : ""
                } w-full px-4 py-2 rounded-2xl`}
                onClick={props.onClick}
            >
                Above
            </button>
            <button
                className={`ml-4 tab ${props.activeTab === 2 ? "active-tab bg-primaryColor text-white" : ""
                } w-full px-4 py-2 rounded-2xl`}
                onClick={props.onClick1}
            >
                Below
            </button>
        </div>
        <div className="flex flex-col mt-6 mb-4">
            <p className="flex justify-start mb-2 ml-2">Price ($)</p>
            <div>
                <input
                    className="w-full bg-gray-200 rounded-2xl px-2 py-2"
                    value={props.value}
                    onChange={props.onChange}
                />
            </div>
        </div>
    </div>;
}